<template>
  <div class="container">
    <h1>点击eg查看console</h1><br>
    <!-- <p v-report.view="['example/KEY_1']">这是首页</p> -->
    <pre style="color:red;width: 100%">this.$buryPoint.report(namespaceWithKey: string, params?: object)</pre>
    <p @click="$buryPoint.report('example/KEY_1')">eg: $buryPoint.report('example/KEY_1')</p>
    <p @click="$buryPoint.report('example/KEY_1', {test: 'test'})">eg: $buryPoint.report('example/KEY_2', {test: 'test'})</p>
    <br>

    <pre style="color:red;">this.$buryPoint.report(namespace: string, points: string | {key: string; params?: object;}[], commonParams?: object)</pre>
    <p @click="$buryPoint.report('example', 'KEY_3,KEY_2', {commonParsms: 'commonParsms'})">
      eg: $buryPoint.report('example', 'KEY_3,KEY_2', {commonParsms: 'commonParsms'})
    </p>
    <p @click="$buryPoint.report('example', [{key: 'KEY_3', params: {params: 'KEY_3'}}, {key: 'KEY_2', params: {params: 'KEY_2'}}], {commonParsms: 'commonParsms'})">
      eg: $buryPoint.report('example', [{key: 'KEY_1', params: {params: 'KEY_1'}}, {key: 'KEY_2', params: {params: 'KEY_2'}}], {commonParsms: 'commonParsms'})
    </p>
    <br>

    <pre style="color:red;">点击事件: v-report="['example/KEY_1', {test: 'test'}]"</pre>
    <p v-report="['example/KEY_1', {test: 'test'}]">
      eg: 测试 v-report="['example/KEY_1', {test: 'test'}]
    </p>
    <br>

    <pre style="color:red;">点击事件: v-report="['example',  'KEY_1', {test: 'test'}]"</pre>
    <p v-report="['example',  'KEY_1', {test: 'test'}]">
      eg: 测试 v-report="['example',  'KEY_1', {test: 'test'}]"
    </p>
    <br>

    <pre style="color:red;">页面UV: v-report.once="['example',  'KEY_1', {test: 'v-report.once'}]"</pre>
    <p v-report.once="['example',  'KEY_1', {test: 'v-report.once'}]">
      eg: 测试 v-report.once="['example',  'KEY_1', {test: 'v-report.once'}]"
    </p>
    <br>

    <pre style="color:red;">
      页面UV: v-report.watch="['example',  'KEY_1', {test: 'watch d.watch'}]" 监听 v-report-watch
    </pre>
    <p v-report.watch="['example',  'KEY_1', {test: 'watch d.watch'}]" v-report-watch="d.watch">
      eg: 测试 v-report.watch="['example',  'KEY_1', {test: 'watch d.watch'}]" 监听 v-report-watch
    </p>
    <button @click="d.watch = !d.watch" >toggle d.watch</button>
    <br>

    <pre style="color:red;">
      页面UV: v-report.watch="['example',  'KEY_1', {test: 'watch d.watch'}]" 监听 v-model
    </pre>
    <XDialog
      v-report.watch="['example',  'KEY_1', {test: 'watch d.model'}]"
      v-model="d.model"
    >
      <p>eg: 测试 v-report.watch="['example',  'KEY_1', {test: 'watch d.model'}]" 监听 v-report-watch</p>
    </XDialog>
    <button @click="d.model = !d.model" >toggle d.model</button>
    <br>

    <pre style="color:red;">
      页面UV: v-report.watch="['example',  'KEY_1', {test: 'watch d.show'}]" 监听 v-show
    </pre>
    <p v-report.watch="['example',  'KEY_1', {test: 'watch d.show'}]" v-show="d.show">
      eg: 测试 v-report.watch="['example',  'KEY_1', {test: 'watch d.show'}]" 监听 v-show
    </p>
    <button @click="d.show = !d.show" >toggle d.show</button>
    <br>

    <pre style="color:red;">
      测试使用异常: v-report.watch.once
    </pre>
    <p v-report.watch.once="['example',  'KEY_1', {test: 'watch d.show'}]" v-show="d.show">
      eg: 测试 v-report.watch.once
    </p>
    <br>

    <pre style="color:red;">
      测试使用异常: v-report.watch with v-if
    </pre>
    <p v-if="d.if" v-report.watch="['example',  'KEY_1', {test: 'watch d.show'}]">
      eg: 测试 v-report.watch with v-if
    </p>
    <br>

    <button @click="$refs.loanTransfer.exec()">loanTransfer</button><br/><br/>
    <button @click="share">share</button>
    <LoanTransfer ref="loanTransfer"/>
    <Marquee actCode="test1,test2"/>
    <Introduce v-report="['example',  'KEY_1', {test: 'watch d.model'}]" @click="noop"/>
    <Introduce  v-report="['example',  'KEY_2', {test: 'watch d.model'}]" @click="noop"/>
    <button @click="test = !test"> 1111111</button>
  </div>
</template>

<script>
import XDialog from '@finance/ssvue/src/components/x-dialog'
import LoanTransfer from '$components/loan-transfer'
import Marquee from '$components/marquee'
import Introduce from '$components/introduce/index'
import share from '$utils/share'

export default {
  components: {
    XDialog,
    LoanTransfer,
    Marquee,
    Introduce
  },
  directives: {
  },
  watch: {
  },
  data() {
    return {
      test: false,
      d: {
        watch: true,
        model: false,
        show: false,
        if: true
      },
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    share() {
      share('title', 'content', 'url')
    },
    noop() {}
  },
}
</script>

<style lang="less" scoped>
.container {
  font-size: 14px;

  pre {
    overflow-x: auto;
    color: #525252;
    white-space: pre;
    line-height: 1.6rem;
    display: block;
  }
}
</style>